module.exports = {"markup":"<span class=\"inline-minus inline-icon\"><svg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\"><rect x=\"5\" y=\"15\" width=\"22\" height=\"3\"></rect></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/minus.svg
// module id = 292
// module chunks = 0 15